export default __webpack_public_path__ + "static/media/banner_control_visual.fc0017ec.png";